module.exports = __webpack_public_path__ + "media/images/logos/bg-cta-6e0de62f5c8af58cccc61bd9d5651547.jpg";